import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import React, { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

export default function InputSearch({
  id,
  value,
  onChange,
  label,
  labelWidth,
  disabled,
  placeholder,
  isRequired = false,
  onSearch,
}) {
  const inputId = useMemo(() => {
    if (!id) {
      return uuidv4();
    }
    return id;
  }, [id]);

  const onChangeValue = (e) => {
    onChange(e.currentTarget.value);
  };

  const inputClasses = () => {
    const baseClasses = `w-full h-full pl-4 py-2.5 text-sm tracking-[.2em] rounded-[10px] border border-[#B3B3B3] !outline-none focus:border-blue-500 `;

    if (disabled) return `${baseClasses} !bg-background-select`;

    return baseClasses;
  };

  return (
    <div className="w-full h-[52px] flex items-center">
      {label ? (
        <label
          htmlFor={inputId}
          className="h-full pr-4 flex items-center"
          style={{
            width: `${labelWidth || 0}px`,
          }}
        >
          <span
            className="w-full text-sm leading-[22px] tracking-[.2em] whitespace-nowrap"
            style={{
              direction: "rtl",
            }}
          >
            {label}
          </span>
          {isRequired && <span style={{ color: "red" }}>*</span>}
        </label>
      ) : null}

      <div
        className={`h-full relative rounded-[10px]`}
        style={{
          width: `calc(100% - ${labelWidth}px)`,
        }}
      >
        <Tooltip arrow title={""}>
          <input
            id={inputId}
            name={inputId}
            value={value}
            placeholder={placeholder}
            onChange={onChangeValue}
            disabled={disabled}
            className={inputClasses()}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSearch();
              }
            }}
            style={{ paddingRight: '35px' }}
          />
        </Tooltip>
        <div className="w-8 h-8 absolute top-[9px] right-1 flex items-center justify-center">
          <FontAwesomeIcon
            icon={faSearch}
            size="lg"
            className="text-lg text-[#001c4f] cursor-pointer"
            onClick={onSearch}
          />
        </div>
      </div>
    </div>
  );
}
